import {ApolloClient, from, InMemoryCache} from '@apollo/client';
import {onError} from '@apollo/client/link/error';
import {GRAPHQL_URL} from '@/libs/constants/url.constants';
import createUploadLink from 'apollo-upload-client/createUploadLink.mjs';
import {setContext} from '@apollo/client/link/context';
import {getAccessToken} from '@/libs/session';
import {redirect, RedirectType} from 'next/navigation';
import {CLIENT_BANNED_MESSAGE, LOGOUT_ROUTE_NAME, UNAUTHORIZED_MESSAGE, UNAUTHORIZED_URL_PARAM} from '@/libs/constants/common.constants';

const httpLink = createUploadLink({
	uri: GRAPHQL_URL,
	credentials: 'include',
});

const errorLink = onError(({ graphQLErrors, networkError, operation, forward }) => {
	if (graphQLErrors) {
		graphQLErrors.forEach(({ message, locations, path }) =>
				console.error(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
		);
	}
	if (networkError) console.error(`[Network error]: ${networkError}`);
	if (graphQLErrors) {
		if (graphQLErrors[0].message === UNAUTHORIZED_MESSAGE) {
			redirect(`${LOGOUT_ROUTE_NAME}?${UNAUTHORIZED_URL_PARAM}=${UNAUTHORIZED_MESSAGE}`, RedirectType.replace);
		} else if (graphQLErrors[0].message === CLIENT_BANNED_MESSAGE) {
			redirect(`${LOGOUT_ROUTE_NAME}?${UNAUTHORIZED_URL_PARAM}=${CLIENT_BANNED_MESSAGE}`, RedirectType.replace);
		}
	}
});

const authLink = setContext(async (ctx, { headers, ...rest }) => {
	const token = await getAccessToken();
	if (!token) {
		return headers;
	}
	
	return {
		headers: {
			...headers,
			Authorization: `Bearer ${token}`
		},
	};
});

export const client = new ApolloClient({
	link: from([errorLink, authLink.concat(httpLink)]),
	cache: new InMemoryCache(),
});
